import { Flex, Divider } from '@chakra-ui/react';
import React from 'react';

import { DisplayNode } from '../../hooks/instanceGraphContext';
import { COLORS, SIZES } from './consts';
import { NodeHeader } from './NodeHeader';

export const NodeDisplay = ({ node }: { node: DisplayNode }) => {
  const { instance, isSelected } = node;
  const instanceStatus = instance?.status || 'none';

  const bkColor = COLORS.nodeNone;
  const borderColor = isSelected
    ? COLORS.selectedBorder
    : COLORS.unselectedBorder;

  return (
    <Flex
      w="300px"
      bg={bkColor}
      border={borderColor}
      boxShadow="0px 4px 6px -1px rgba(0, 0, 0, 0.10), 0px 2px 4px -1px rgba(0, 0, 0, 0.06)"
      borderRadius={SIZES.borderRadius}
      flexDirection="column"
    >
      <NodeHeader node={node} extendedStatus={instanceStatus} />
      <Divider borderColor={COLORS.divider} />
    </Flex>
  );
};
